import type { Theme } from '../types';
import { Stars } from './Stars';

// Space — deep night sky with twinkling stars.
export const spaceTheme: Theme = {
  key: 'space',
  name: 'Avaruus',
  tokens: {
    bodyBackground: 'radial-gradient(ellipse at top, #2a1d63 0%, #0f0822 100%)',
    pageHeadingColor: '#ffffff',
    pageHeadingShadow: '0 0 18px rgba(168, 85, 247, 0.7)',
    routineCardSurface: 'rgba(255, 255, 255, 0.18)',
    cardSurface: 'rgba(255, 255, 255, 0.92)',
    accent: '#a855f7',
  },
  decoration: { kind: 'component', component: Stars },
  routineCardPalette: ['#a855f7', '#22d3ee', '#facc15', '#f472b6', '#34d399', '#fb923c'],
};
